import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default function LogoIcon(props) {
  return (
    <SvgIcon {...props} width="17" height="20" viewBox="0 0 17 20" fill="none">
      <path
        d="M16.7015 14.5949C16.2487 15.6006 16.0305 16.0502 15.448 16.9377C14.6326 18.178 13.4826 19.7268 12.0618 19.7366C10.7969 19.7481 10.4704 18.9114 8.75264 18.9262C7.03655 18.9344 6.67889 19.753 5.41233 19.7399C3.98991 19.7268 2.90217 18.3323 2.08678 17.0936C-0.193685 13.6204 -0.434857 9.54836 0.97444 7.38273C1.97194 5.84711 3.54858 4.94477 5.03007 4.94477C6.53944 4.94477 7.48772 5.77328 8.7346 5.77328C9.94538 5.77328 10.682 4.94313 12.4276 4.94313C13.7467 4.94313 15.1412 5.66172 16.1387 6.90203C12.8772 8.69031 13.4071 13.348 16.7015 14.5949ZM11.102 3.5568C11.7369 2.74141 12.2193 1.59133 12.0437 0.419922C11.0085 0.490469 9.79772 1.15164 9.09061 2.00805C8.44913 2.78898 7.91756 3.94727 8.12428 5.06781C9.25467 5.10391 10.4244 4.42961 11.102 3.5568Z"
        fill="white"
      />
    </SvgIcon>
  );
}



// WEBPACK FOOTER //
// ./src/icons/AppleIcon.jsx